module.exports = __webpack_public_path__ + "img/icon-yellow-process.0461c726.svg";